import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { AbstractContentPane } from '@app/library/panes/models/abstract-content-pane';
import { NoContentStubComponent } from '@core/components/no-content-stub/no-content-stub.component';
import { SpinnersModule } from '@core/components/spinners/spinners.module';

@Component({
  selector: 'app-schools-news',
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, SpinnersModule, NoContentStubComponent],
  templateUrl: './schools-news.component.html',
  styleUrls: ['./schools-news.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SchoolsNewsComponent extends AbstractContentPane {
  public navigate(): void {
    void this.router.navigateByUrl('schools').catch();
  }

  protected onContentLoaded() {
    this.isVisible = true;
  }
}
